import { Camera, Building2, BedDouble, Search } from "lucide-react";

const items = [
  { id: "ugc", no: "A", icon: Camera, title: "客人自發分享變多", text: "UGC 變 3 倍，曝光再多一倍" },
  { id: "team", no: "B", icon: Building2, title: "公司團建變多", text: "詢問 2 倍以上，業績 +8%～25%" },
  { id: "ota", no: "C", icon: BedDouble, title: "訂房網站訂房增加", text: "Agoda／Booking／Trip 點擊多 0.7%～1%" },
  { id: "google", no: "D", icon: Search, title: "Google 搜尋直達官網", text: "搜尋點進官網人客多專案頁" },
];

export const FourBenefits = () => (
  <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
    {items.map((b) => (
      <a key={b.id} href={`#benefit-${b.id}`} data-testid={`benefit-card-${b.id}`} className="lift rounded-3xl border border-[var(--line)] bg-white p-5">
        <div className="flex items-center justify-between">
          <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#47BBBC]/15 text-[var(--teal-d)]"><b.icon size={24} /></span>
          <span className="text-2xl font-black text-[#47BBBC]/50">{b.no}</span>
        </div>
        <p className="mt-4 font-black text-[var(--ink)]">{b.title}</p>
        <p className="mt-1 text-sm text-[var(--text)]">{b.text}</p>
      </a>
    ))}
  </div>
);
